import { render, staticRenderFns } from "./ServiceTicketForm.vue?vue&type=template&id=687d7c0c&scoped=true&"
import script from "./ServiceTicketForm.vue?vue&type=script&lang=js&"
export * from "./ServiceTicketForm.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTicketForm.vue?vue&type=style&index=0&id=687d7c0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687d7c0c",
  null
  
)

export default component.exports